import { render, staticRenderFns } from "./curso-resultado-preguntas.vue?vue&type=template&id=e80e3308&scoped=true&"
import script from "./curso-resultado-preguntas.vue?vue&type=script&lang=ts&"
export * from "./curso-resultado-preguntas.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e80e3308",
  null
  
)

export default component.exports